import styled from 'styled-components';
import { allCaps2Styles, body4Styles } from '../../typography/style';
export var DropdownMenu = /*#__PURE__*/styled.ul.withConfig({
  displayName: "style__DropdownMenu",
  componentId: "s5ka7d-0"
})(["width:100%;border:1px solid ", ";border-radius:0 0 4px 4px;background-color:", ";box-shadow:1px 2px 2px 0 ", ",2px 4px 6px 1px ", ";position:absolute;left:0;right:0;z-index:", ";top:", ";", ";", ";"], p => p.theme.colors.gray100, p => p.theme.colors.white, p => p.theme.colors.shadow100, p => p.theme.colors.shadow50, p => p.theme.zIndex.dropdown, p => p.wrapsTextInput && '60px', p => p.numberOfItemsToBeShown && "max-height: ".concat(p.numberOfItemsToBeShown * 54, "px"), p => p.numberOfItemsToBeShown && 'overflow-y: scroll');
export var NoResultItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__NoResultItem",
  componentId: "s5ka7d-1"
})(["", ";cursor:pointer;background-color:transparent;color:", ";"], allCaps2Styles, p => p.theme.colors.gray600);
export var DropdownItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "style__DropdownItem",
  componentId: "s5ka7d-2"
})(["", ";cursor:pointer;background-color:transparent;color:", ";padding:14.5px;&:focus,&:hover{color:", ";}"], body4Styles, p => p.theme.colors.gray600, p => p.theme.colors.black);
export var StyleDropdownMenu = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__StyleDropdownMenu",
  componentId: "s5ka7d-3"
})(["position:relative;"]);